define(["backbone", "../baseModels/collaborationFeaturesModel"], function (
  Backbone,
  CollaborationFeaturesModel,
) {
  "use strict";
  const TrackChangesModel = {};

  const SUGGESTION_STATES = {
    OPEN: "open",
    ACCEPTED: "accepted",
    REJECTED: "rejected",
  };

  TrackChangesModel.suggestion = CollaborationFeaturesModel.base.extend({
    idAttribute: "id",
    defaults: {
      ckSuggestionId: "",
      templateId: 0,
      data: "",
      state: SUGGESTION_STATES.OPEN,
    },
  });

  TrackChangesModel.suggestions = Backbone.Collection.extend({
    model: TrackChangesModel.suggestion,
  });

  return TrackChangesModel;
});
